import {atom, useAtom} from 'jotai';
import { Permission } from '../types';
import { useLocation } from 'react-router-dom';

export const permissonAtom = atom<Permission[]>([]);
export const allClientPermissonAtom = atom<Permission[]>([]);

export const useGlobalAtoms = () => {
  const location = useLocation();
  const [permissions, setPermissions] = useAtom(permissonAtom);
  const [allClientPermissons, setAllClientPermissons] = useAtom(allClientPermissonAtom);


  const checkPermission = () => {
    const pageName = location.pathname;
    if (pageName == '/') return true;

    let findPage = false;
    for (let i=0; i<permissions.length; i++) {
      if (pageName.startsWith(permissions[i].url ?? '')) {
        findPage = true;
        break;
      }
    }
    return findPage;
  }

  return {
    permissions,
    setPermissions,
    allClientPermissons,
    setAllClientPermissons,
    checkPermission,
  };
};
